import { render, staticRenderFns } from "./JudgingCriteriaEdit.vue?vue&type=template&id=5a032390&scoped=true"
import script from "./JudgingCriteriaEdit.vue?vue&type=script&lang=js"
export * from "./JudgingCriteriaEdit.vue?vue&type=script&lang=js"
import style0 from "./JudgingCriteriaEdit.vue?vue&type=style&index=0&id=5a032390&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a032390",
  null
  
)

export default component.exports